<template>

    <div
        v-if="typeof msg == 'object'"
        class="container-tooltip"
    >
        <button
            class="tooltip-target"
            @click="clickOut = !clickOut"
        >
            {{ btnTitle }}
        </button>

        <div
            v-if="clickOut"
            :class="{
                'tooltip-down': screenHeight > 500,
                'tooltip': screenHeight < 500
            }"
            @mouseleave="clickOut = !clickOut"
        >
            <div
                class="tooltip-content scroll-color"
            >
                <span
                    v-for="(item, index) in msg"
                    :key="index"
                    class="tooltip-text"
                >
                    {{ setEllipsisText(item.name) }}
                </span>
            </div>
        </div>
    </div>
</template>


<script>
	export default {
		name: 'ui-tooltip',

		props: {
			msg: {
				type: [String, Array],
				default: () => []
			},

			btnTitle: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				clickOut: false,
				screenHeight: window.innerHeight
			}
		},

        mounted() {
            // Adiciona um ouvinte de evento de redimensionamento
            window.addEventListener('resize', this.handleResize)
        },

        beforeDestroy() {
            // Remove o ouvinte de evento de redimensionamento antes de destruir o componente
            window.removeEventListener('resize', this.handleResize)
        },

        methods: {
            setEllipsisText(text) {
                const arrText = text.split(',').map(name => {
                    if (name.length > 26) {
                        return text.substring(0, 26) + '...'
                    } else {
                        return text
                    }
                })
                return arrText[0]
            },

            handleResize() {
            // Atualiza a altura da tela quando o evento de redimensionamento ocorre
                this.screenHeight = window.innerHeight
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import 'style.styl';
</style>
